import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { RadioButtons } from "../../../FlowConfigurationInputs";
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import VariablePicker from "../../../FlowConfigurationInputs/VariablePicker/VariablePicker";

/**
 * @Description this page String Library's Replace Action's configuration form
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRender - variable render
 * @Returns     div element
 * @Author      Kerem Karadeniz
 */
export default function Replace({
  action,
  variables,
  setOpenVariable,
  variableRender,
  setField,
  disabled,
  outputVisible
}) {
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.STRING.";
  const options = {
    radioButtons: {
      data: [
        {
          value: "active",
          label: label + "MATCHCASE",
        },
        {
          value: "passive",
          label: label + "NOTMATCHCASE",
        },
      ],
      defaultValue: "active",
    },
  };

  return (
    <div>
      <div className="form-element">
        {t(label + "SOURCESTRING")}
        <TextInput
          action={action}
          inputName="sourceString"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          disabled={disabled}
          setField={setField}
          displayName={t(label + "SOURCESTRING")}
          fieldType={"string"}
        />
      </div>
      <div className="form-element">
        {t(label + "FINDSTRING")}
        <TextInput
          action={action}
          inputName="findString"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          setField={setField}
          displayName={t(label + "FINDSTRING")}
          fieldType={"string"}
        />
      </div>
      <div className="form-element">
        <strong>{t(label + "FINDING")}</strong>
        <RadioButtons
          action={action}
          inputName="isMatchCase"
          isRequired={true}
          options={options.radioButtons}
          setField={setField}
        />
      </div>
      <div className="form-element">
        {t(label + "REPLACEWITH")}
        <TextInput
          action={action}
          inputName="replaceWith"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={false}
          setField={setField}
          displayName={t(label + "REPLACEWITH")}
          fieldType={"string"}
        />
      </div>
      {
        !outputVisible && <div className="form-element">
          {t("CONTENT.CONFIGURATION-FORM.STRING.ASSIGN_TO_VARIABLE")}
          <VariablePicker
            action={action}
            inputName="set"
            variables={variables}
            setOpenVariable={setOpenVariable}
            variableRender={variableRender}
            disabled={disabled}
            isRequired
          />
        </div>
      }

    </div>
  );
}
